import { useTranslation } from 'react-i18next'
import { GitMerge, GitPullRequest, GitPullRequestClosed } from 'lucide-react'
import { mostRelevantPr, usePullRequests } from '@/lib/db/rxdb/hooks'
import { cn } from '@/lib/utils'

/**
 * Compact linked-PR indicator for a task row (list views). Shows the most relevant PR's state,
 * tinted red when its CI is failing. Renders nothing when the task has no linked PRs. Only
 * mounts for visible (virtualized) rows; the query is indexed on (envId, taskId).
 */
export function TaskPrIndicator({ taskId, className }: { taskId: string; className?: string }) {
  const { t } = useTranslation('tasks')
  const { pullRequests } = usePullRequests(taskId)
  const pr = mostRelevantPr(pullRequests)
  if (!pr) return null

  const Icon = pr.state === 'merged' ? GitMerge : pr.state === 'closed' ? GitPullRequestClosed : GitPullRequest
  return (
    <span
      className={cn(
        'shrink-0 text-muted-foreground/70',
        pr.ciStatus === 'failing' && 'text-destructive',
        pr.state === 'merged' && 'text-muted-foreground',
        className,
      )}
      title={t(`pullRequests.state.${pr.state}`, pr.state)}
    >
      <Icon className="size-3.5" />
    </span>
  )
}
